import { gql } from '@apollo/client'

export const airPriceGuideRetailOW = gql`
  query apolloClientAirPriceGuideRetailOW($input: AirPriceGuideRequest) {
    airPriceGuide(input: $input) {
      error {
        type
        code
        message
      }
      total
      viewers
      records {
        viewers
        destinations {
          airportCode
          cityCode
          stateCode
          countryCode
        }
        origins {
          airportCode
          cityCode
          stateCode
          countryCode
        }
        dates
        cabinClass
        paxChild
        paxInfant
        paxAdult
        currencyCode
        minimumFare {
          isPrivateFare
          currency
          amtPerPax
          commonAttributes {
            takeOffTimes
            landingTimes
          }
          listOfStops {
            sliceId
            stops
          }
        }
      }
    }
  }
`

export const airPriceGuideExpressDealOW = gql`
  query apolloClientAirPriceGuideEXDOW($input: AirPriceGuideRequest) {
    airPriceGuide(input: $input) {
      error {
        type
        code
        message
      }
      total
      viewers
      records {
        viewers
        destinations {
          airportCode
          cityCode
          stateCode
          countryCode
        }
        origins {
          airportCode
          cityCode
          stateCode
          countryCode
        }
        dates
        cabinClass
        paxChild
        paxInfant
        paxAdult
        currencyCode
        minimumFare {
          isPrivateFare
          currency
          amtPerPax
          commonAttributes {
            takeOffTimes
            landingTimes
          }
          listOfStops {
            sliceId
            stops
          }
        }
      }
    }
  }
`

export const airPriceGuideNumViewers = gql`
query apolloClientAirPriceGuideNumViewers($input:AirPriceGuideRequest) {
  airPriceGuide(input: $input) {
    viewers
  }
}`

export const airPriceGuideExpressDealRT = gql`
  query apolloClientAirPriceGuideExpressDealRT($input:AirPriceGuideRequest) {
    airPriceGuide(input: $input) {
      error {
        type
        code
        message
      }
      total
      viewers
      records {
        viewers
        destinations {
          airportCode
          cityCode
          stateCode
          countryCode
        }
        origins {
          airportCode
          cityCode
          stateCode
          countryCode
        }
        dates
        cabinClass
        paxChild
        paxInfant
        paxAdult
        currencyCode
        minimumFare {
          isPrivateFare
          currency
          amtPerPax
          commonAttributes {
            takeOffTimes
            landingTimes
          }
          listOfStops {
            sliceId
            stops
          }
        }
      }
    }
  }
`

export const airPriceGuideRetailRT = gql`
  query apolloClientAirPriceGuideRetailRT($input:AirPriceGuideRequest) {
    airPriceGuide(input: $input) {
      error {
        type
        code
        message
      }
      total
      viewers
      records {
        viewers
        destinations {
          airportCode
          cityCode
          stateCode
          countryCode
        }
        origins {
          airportCode
          cityCode
          stateCode
          countryCode
        }
        dates
        cabinClass
        paxChild
        paxInfant
        paxAdult
        currencyCode
        minimumFare {
          isPrivateFare
          currency
          amtPerPax
          commonAttributes {
            takeOffTimes
            landingTimes
          }
          listOfStops {
            sliceId
            stops
          }
        }
      }
    }
  }
`
